<template>
  <div class="exportFileBtnBox">
    <el-button type="primary" :round="round" v-debounce="exportData" class="button-small" :before-close="closeDialog" :style="buttonStyle" v-bind="$attrs">{{ displayBtnText }}</el-button>
    <el-dialog
      width="500px"
      :append-to-body="dialogAppendToBody"
      :custom-class="dialogCustomClass"
      :visible.sync="visibleDialog"
      :title="$t('common.exportTip')"
    >
      <div class="ticpDialog">
        <div class="ticpDialog_message"><i class="el-icon-circle-check"></i>{{ exportMessage }}</div>
        <div class="ticpDialog_ticp">{{ $t('common.exportGoToPrefix') }}<span @click="goToFileList">{{ $t('common.importExport') }}</span>{{ $t('common.exportGoToSuffix') }}</div>
      </div>
      <div class="operatebtn">
        <el-button size="small" @click="closeDialog">{{ $t('common.notNow') }}</el-button>
        <el-button type="primary" size="small" @click="goToFileList">{{ $t('common.goToExportDownload') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportFileBase } from "@/api/basicApi";
import {getBasicUrls, reportURL} from "@/util/config";
import axios from "axios";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  name: "exportFileBtn",
  props: {
    // 按钮是否添加圆角
    round: {
      type: Boolean,
      default: true
    },
    // 按钮文案，不传则使用 common.export 按当前语言显示
    btnText: {
      type: String,
      default: ""
    },
    // 导出接口传递参数
    params: {
      type: Object | String | Number | Array | Boolean,
      default: () => {
        return {};
      }
    },
    // 导出接口路径
    apiUrl: {
      type: String,
      default: null
    },
    // 按钮行内样式
    buttonStyle: {
      type: Object,
      default: () => {
        return {
          marginRight: '10px'
        };
      }
    },
    // 请求添加方式
    options: {
      type: Object,
      default: () => ({})
    },
    // 是否为文件流方式，如果是，需要在次调用一个接口获取导出状态
    isFile: {
      type: Boolean,
      default: false
    },
    // 文件名称
    fileName: {
      type: String,
      default: String(new Date().getTime()) // 默认值为时间戳
    },
    exportRules: {
      type: Function,
      default: () => {
        return () => {
          return true;
        };
      }
    },
    dialogAppendToBody: {
      type: Boolean,
      default: false
    },
    dialogCustomClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayBtnText() {
      return this.btnText || this.$t('common.export');
    }
  },
  data() {
    return {
      visibleDialog: false,
      exportMessage: ''
    };
  },
    watch: {
    visibleDialog(val) {
      if (val) this.exportMessage = this.$t('common.exportSubmitSuccess');
    }
  },
  methods: {
    closeDialog() {
      this.visibleDialog = false;
    },
    async exportData() {
      try {
        console.log('当前导出接口传递参数', this.params);
        if (!this.exportRules()) return;
        if (this.isFile) return (this.getFileData()); // 如果是文件流格式，需要调用另一个接口
        if (!this.apiUrl) return (this.$message.warning(this.$t('common.exportApiRequired')));
        const res = await exportFileBase(this.apiUrl, this.params, this.options);
        console.log('导出结果', res);
        if (res.code === 1029) {
          this.exportMessage = this.$t('common.exportSubmitSuccess');
          this.visibleDialog = true;
          this.$store.dispatch('getExportFileStatus', 1);
          return;
        }
        this.$message.warning(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('common.exportFailed'));
      } catch (err) {
        console.error('导出组件内部报错', err);
        this.$message.error(this.$t('common.systemErrorContactAdmin'));
      }
    },
    goToFileList() {
      this.$router.push("/main/ExportImportQuery");
      this.visibleDialog = false;
    },
    async getFileData() {
      const params = await this.params;
      console.log('当前文件流导出参数', params);
      await this.exportExl(
        `${this.apiUrl}`,
        params,
        `${this.fileName ||
        this.apiUrl.replace(/^(\S*:)(\S*\.)(\S*\.)(\S*)$/, "$2")}_${new Date().getTime()/1000}`
      );
    },
    async exportExl(url, data = {}, fileName = "", methods = "post") {
      const _this = this
      let xhr = new XMLHttpRequest();
      xhr.open(methods, `${reportURL()}ureport/excel`, true);
      xhr.responseType = "blob";
      xhr.setRequestHeader("Authorization", LoginUserHelper.getUserToken()); // 请求头中的验证信息等（如果有）
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = async function () {
        if (this.status === 200) {
          //报错信息是json数据，处理报错信息
          let type = xhr.getResponseHeader("Content-Type");
          if(type == 'application/json'){
            let reader = new FileReader()
            reader.readAsText(this.response)
            reader.onload = function (res){
              let datas = JSON.parse(res.target.result)
              if(datas.code){
                _this.$message.error(this.$getCodeMessage(datas.code, datas.message, datas.messageArgs) || _this.$t('common.systemErrorContactAdmin'));
              }
            }
            return
          }
          try {
            const params = new FormData();
            params.append('file', this.response, fileName); // 将文件流添加到 FormData 对象中
            params.append('fileName', fileName);
            // 使用 axios 发送 FormData 对象到后端
            const response = await axios({
              method: "post",
              headers: {
                "Content-Type": "multipart/form-data",
              },
              url: getBasicUrls().schoolm + 'api/manage/schoolimport/reportUploadData',
              data: params,
            });
            console.log('上传>>>>>>', response)
            if (response.code === 0) {
              console.log('异步导出任务提交成功');
              _this.visibleDialog = true;
              _this.$store.dispatch('getExportFileStatus', 1);
              return;
            }
            _this.$message.warning(_this.$getCodeMessage(response.code, response.message, response.messageArgs) || _this.$t('common.exportFailed'));
          } catch (err) {
            console.log('导出组件内部报错>>>>>', err)
            _this.$message.error(_this.$t('common.systemErrorContactAdmin'));
          }
        }
      };
      xhr.send(data);
    }
  }
}
</script>

<style scoped lang="scss">
.exportFileBtnBox {
  display: inline-block;
  .ticpDialog {
    .ticpDialog_message {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;

      i {
        color: #67C23A;
        padding-right: 5px;
      }
    }

    .ticpDialog_ticp {
      font-size: 14px;
      color: #999;
      margin-bottom: 20px;

      span {
        color: #02b6b9;
        cursor: pointer;
      }
    }
  }

  .operatebtn {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
